module.exports = __webpack_public_path__ + "static/media/shopify-logo-2018.ee306d89.svg";